export default function detection (agent) {
  let comp_agent = agent.indexOf("tv build/ion") != -1;
  if (comp_agent) {
    console.info ("[SEI Robotics detection] detected");
    console.info ("[SEI Robotics detection] user agent: " + agent);
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/seirobotics/detection.js